import { defineStore } from 'pinia'

export interface AngleInfoState {
  visible: boolean,
  text: string,
  value: number
}

const initialState = (): AngleInfoState => ({
  visible: false,
  text: '',
  value: 0
})

export const angleInfoState = defineStore('angleInfoState', {
  state: initialState
})
